import { ROUTES } from "@/routes/constants/routes";

const SIDEBAR_ACTIVE_ALIASES: Record<string, readonly string[]> = {};

function matchesPathPrefix(currentPath: string, prefix: string): boolean {
  return currentPath === prefix || currentPath.startsWith(`${prefix}/`);
}

export function isSidebarRouteActive(checkedPath: string, currentPath: string): boolean {
  if (!checkedPath) {
    return false;
  }

  if (checkedPath === ROUTES.DASHBOARD.HOME) {
    return checkedPath === currentPath;
  }

  if (matchesPathPrefix(currentPath, checkedPath)) {
    return true;
  }

  const aliases = SIDEBAR_ACTIVE_ALIASES[checkedPath];
  return aliases?.some((alias) => matchesPathPrefix(currentPath, alias)) ?? false;
}
